module.exports = __webpack_public_path__ + "img/illustration-create-profile.d4720778.svg";